(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
            const feesAndTotals = document.querySelector('[data-fees-and-totals]');
            const subtotal = document.querySelector('[data-subtotal]');

            const renderFees = () => {
                const fees = {};
                feesAndTotals.querySelectorAll('[data-fee-hidden-calc-price]').forEach((feeBlock) => {
                    const feeLabel = feeBlock.querySelector('.mws-fee-label-title');
                    if (!feeLabel) {
                        return;
                    }
                    const feeName = feeLabel.textContent.replace('&nbsp;', '').trim();
                    fees[feeName] = (fees[feeName] || 0) + Number(feeBlock.dataset.feeHiddenCalcPrice);
                });

                if (Object.keys(fees).length === 0) {
                    return;
                }

                subtotal.querySelectorAll('[data-fee-row]').forEach((row) => row.remove());

                const placeholders = subtotal.querySelectorAll('[data-placeholder]');
                Object.entries(fees).forEach(([feeName, feePrice]) => {
                    const labelNode = document.createElement('p');
                    const priceNode = document.createElement('p');
                    labelNode.setAttribute('data-fee-row', '');
                    priceNode.setAttribute('data-fee-row', '');
                    labelNode.classList.add('h-full', 'text-xl', 'py-6', 'border-t', 'border-gray');
                    priceNode.classList.add('h-full', 'grid', 'items-center', 'text-xl', 'pr-8', 'py-6', 'border-t', 'border-gray');
                    labelNode.textContent = feeName;
                    priceNode.textContent = Intl.NumberFormat('en-NZ', { style: 'currency', currency: 'NZD' }).format(feePrice);
                    subtotal.insertBefore(labelNode, placeholders[0]);
                    subtotal.insertBefore(priceNode, placeholders[0]);
                });

                placeholders.forEach((placeholder) => placeholder.classList.add('hidden'));
            };

            const mutationObserver = new MutationObserver(renderFees);
            mutationObserver.observe(feesAndTotals, {
                childList: true,
            });
            renderFees();
        
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
    window.location.href = '/collections/all';

  } catch(e) { console.error(e); }
})();
})();
